import {
	Box,
	Button,
	CircularProgress,
	Typography,
	styled
} from '@mui/material';
import clsx from 'clsx';
import React, { useState } from 'react';
import { useDropzone } from 'react-dropzone';

const IMAGE_WIDTH = 240;

const StyledImage = styled('img')(({ size }) => ({
	padding: 2,
	borderRadius: 4,
	marginRight: 8,
	width: size,
	'&.circle': {
		borderRadius: 100
	}
}));

const StyledDropZone = styled(Box)({
	margin: 0,
	height: 140,
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	border: '1px dotted #777777',
	backgroundColor: '#fff',
	textAlign: 'center',
	marginBottom: 16
});

const StyledButton = styled(Button)({
	fontSize: 11,
	textTransform: 'uppercase'
});

const ImageUploader = ({
	circle = false,
	handleUpload,
	label = 'Upload image',
	size = IMAGE_WIDTH,
	imageUrl,
	handleDelete,
	...props
}) => {
	const [isEditing, setIsEditing] = useState(false);
	const [file, setFile] = useState();
	const [files, setFiles] = useState([]);
	const [isUploading, setIsUploading] = useState(false);
	const [isUploaded, setIsUploaded] = useState(false);
	const [dropzoneActive, setDropzoneActive] = useState(false);

	const onDrop = async (files) => {
		setIsUploading(true);
		setIsUploaded(false);
		await handleUpload(files[0]);
		setIsEditing(false);
		setIsUploading(false);
		setIsUploaded(true);
		setFiles([]);
		setFile(null);
	};

	const { getRootProps, getInputProps } = useDropzone({
		onDrop,
		accept: {
			'image/*': []
		}
	});

	return (
		<div>
			{imageUrl && !isEditing && (
				<StyledImage
					className={clsx({
						circle: circle
					})}
					size={size}
					src={imageUrl}
				/>
			)}

			{(isEditing || !imageUrl) && (
				<StyledDropZone {...getRootProps()}>
					<input {...getInputProps()} />
					{!isUploaded && !isUploading && !dropzoneActive && (
						<Typography variant="overline">{label}</Typography>
					)}

					{isUploaded && (
						<Typography variant="overline">Upload complete</Typography>
					)}

					{!isUploaded && !isUploading && dropzoneActive && (
						<Typography variant="overline">Drop image</Typography>
					)}

					{!isUploaded && isUploading && <CircularProgress color="primary" />}
				</StyledDropZone>
			)}

			{imageUrl && handleDelete && (
				<Box mb={2}>
					<StyledButton color="secondary" size="small" onClick={handleDelete}>
						Remove
					</StyledButton>
				</Box>
			)}
		</div>
	);
};

export default ImageUploader;
